import axios from "axios";

export const getCurrentDTSVersion = async (
  msdCompound: string,
  supplierOrg: string,
  transferId: string,
) => {
  const apiUrl = `${process.env.REACT_APP_PROXY_URL}/v1/fetchDtsVersion`;

  try {
    const response = await axios.post(
      apiUrl,
      {
        msd_compound: msdCompound,
        supplier_org: supplierOrg,
        transfer_id: transferId,
      },
      {
        headers: {
          Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
          "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
        },
      },
    );
    return response.data;
  } catch (err: any) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error("An unexpected error occurred");
    }
  }
};
